// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-Companies-styles___loaderWrapper--oYUDS {
  position: relative;
}
.pages-Companies-styles___tabs--cSemB,
.pages-Companies-styles___tab--XNwGS {
  text-transform: initial !important;
}
.pages-Companies-styles___tabs--cSemB {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 35px;
}
.pages-Companies-styles___loyalityTabs--gixpI {
  margin-top: 16px;
}
.pages-Companies-styles___loyalityTabs--gixpI .pages-Companies-styles___tab--XNwGS {
    flex: 1;
    min-width: unset;
  }
.pages-Companies-styles___companyNameContainer--W2mno {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pages-Companies-styles___companyNameContainer--W2mno .pages-Companies-styles___chips--Zb1oC {
    display: flex;
    align-items: center;
    margin: 0 0 0 32px;
  }
.pages-Companies-styles___companyNameContainer--W2mno .pages-Companies-styles___brex--VDu6m {
    height: 32px;
    width: 59px;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    background: #e9794b;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 16px 0 0;
  }
.pages-Companies-styles___companyNameContainer--W2mno .pages-Companies-styles___agency--GWuX9 {
    height: 32px;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    margin: 0 16px 0 0;
  }
.pages-Companies-styles___companyNameContainer--W2mno .pages-Companies-styles___fraud--XImri {
    background: #fc3b60;
    width: 99px;
    border-radius: 4px;
    font-size: 13px;
    color: #ffffff;
    letter-spacing: 0;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Roboto';
    font-weight: 600;
  }
.pages-Companies-styles___companyNameContainer--W2mno .pages-Companies-styles___fraud--XImri span {
      padding: 6px;
    }
.pages-Companies-styles___labelStatusDisabled--_UDUv {
  font-family: 'Roboto';
  font-size: 13px;
  color: #1b2432;
  letter-spacing: 0;
  text-align: center;
  background: rgba(252, 59, 96, 0.1);
  border: 1px solid #fc3b60;
  border-radius: 4px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: -moz-fit-content;
  width: fit-content;
  padding-left: 8px;
  padding-right: 8px;
}
.pages-Companies-styles___buttonDeactivateCompany--TtNCA {
  border: 1px solid #fc3b60 !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 161px !important;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}
.pages-Companies-styles___deactivateCompanyButtonContainer--dCGEW {
  display: flex;
  justify-content: flex-start;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}
.pages-Companies-styles___buttonReactivateCompany--DbHYH {
  border: 1px solid #318afb !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 161px !important;
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
}
.pages-Companies-styles___reactivateCompanyButtonContainer--CZ4B1 {
  display: flex;
  justify-content: flex-start;
  font-size: 13px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
}
.pages-Companies-styles___container--V6YS4 {
  display: flex;
}
.pages-Companies-styles___container--V6YS4 .pages-Companies-styles___content--MSAuv {
    flex: 1;
    margin-right: 30px;
  }
.pages-Companies-styles___container--V6YS4 .pages-Companies-styles___sidebar--hp7OY {
    flex: 352px 0 1;
    min-width: 300px;
  }
.pages-Companies-styles___importTextContainer--ojdaH {
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);
  border-radius: 4px;
  font-family: 'Roboto';
  font-weight: 600;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  height: 52px;
  margin-bottom: 8px;
  margin-top: 20px;
}
.pages-Companies-styles___importTextContainer--ojdaH.pages-Companies-styles___info--eGlso {
    border-left: 4px solid #12da9f;
  }
.pages-Companies-styles___importTextContainer--ojdaH.pages-Companies-styles___warn--W451H {
    border-left: 4px solid #fca33b;
  }
.pages-Companies-styles___importTextContainer--ojdaH.pages-Companies-styles___error--a7MOo {
    border-left: 4px solid #fc3b60;
  }
.pages-Companies-styles___importTextContainer--ojdaH svg {
    margin-left: 25px;
    margin-right: 8px;
  }
.pages-Companies-styles___csvtables--TQxlL {
  margin-bottom: 100px;
}
.pages-Companies-styles___tableClass--jlyru {
  max-height: 300px;
}
.pages-Companies-styles___simple--wCqNX td {
    color: #6d717a;
  }
.pages-Companies-styles___withHeader--AsBLM th {
    color: #6d717a !important;
  }
`, "",{"version":3,"sources":["webpack://./pages/Companies/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;;EAEE,kCAAkC;AACpC;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AAEA;EACE,gBAAgB;AAMlB;AAJE;IACE,OAAO;IACP,gBAAgB;EAClB;AAGF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AAqDrB;AAnDE;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;AAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;AAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;EACpB;AAEA;IACE,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;EAKlB;AAHE;MACE,YAAY;IACd;AAIJ;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,aAAa;AAWf;AATE;IACE,OAAO;IACP,kBAAkB;EACpB;AAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AAGF;EACE,mBAAmB;EACnB,iDAAiD;EACjD,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAkBlB;AAhBE;IACE,8BAA8B;EAChC;AAEA;IACE,8BAA8B;EAChC;AAEA;IACE,8BAA8B;EAChC;AAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AAGF;EACE,oBAAoB;AACtB;AAEA;EACE,iBAAiB;AACnB;AAGE;IACE,cAAc;EAChB;AAIA;IACE,yBAAyB;EAC3B","sourcesContent":[".loaderWrapper {\n  position: relative;\n}\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 35px;\n}\n\n.loyalityTabs {\n  margin-top: 16px;\n\n  .tab {\n    flex: 1;\n    min-width: unset;\n  }\n}\n\n.companyNameContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .chips {\n    display: flex;\n    align-items: center;\n    margin: 0 0 0 32px;\n  }\n\n  .brex {\n    height: 32px;\n    width: 59px;\n    font-size: 13px;\n    color: #ffffff;\n    letter-spacing: 0;\n    background: #e9794b;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 16px 0 0;\n  }\n\n  .agency {\n    height: 32px;\n    font-size: 13px;\n    color: #ffffff;\n    letter-spacing: 0;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0 16px;\n    margin: 0 16px 0 0;\n  }\n\n  .fraud {\n    background: #fc3b60;\n    width: 99px;\n    border-radius: 4px;\n    font-size: 13px;\n    color: #ffffff;\n    letter-spacing: 0;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Roboto';\n    font-weight: 600;\n\n    span {\n      padding: 6px;\n    }\n  }\n}\n\n.labelStatusDisabled {\n  font-family: 'Roboto';\n  font-size: 13px;\n  color: #1b2432;\n  letter-spacing: 0;\n  text-align: center;\n  background: rgba(252, 59, 96, 0.1);\n  border: 1px solid #fc3b60;\n  border-radius: 4px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: fit-content;\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.buttonDeactivateCompany {\n  border: 1px solid #fc3b60 !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  min-width: 161px !important;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.deactivateCompanyButtonContainer {\n  display: flex;\n  justify-content: flex-start;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.buttonReactivateCompany {\n  border: 1px solid #318afb !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  min-width: 161px !important;\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.reactivateCompanyButtonContainer {\n  display: flex;\n  justify-content: flex-start;\n  font-size: 13px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.container {\n  display: flex;\n\n  .content {\n    flex: 1;\n    margin-right: 30px;\n  }\n\n  .sidebar {\n    flex: 352px 0 1;\n    min-width: 300px;\n  }\n}\n\n.importTextContainer {\n  background: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(109, 113, 122, 0.15);\n  border-radius: 4px;\n  font-family: 'Roboto';\n  font-weight: 600;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  display: flex;\n  align-items: center;\n  height: 52px;\n  margin-bottom: 8px;\n  margin-top: 20px;\n\n  &.info {\n    border-left: 4px solid #12da9f;\n  }\n\n  &.warn {\n    border-left: 4px solid #fca33b;\n  }\n\n  &.error {\n    border-left: 4px solid #fc3b60;\n  }\n\n  svg {\n    margin-left: 25px;\n    margin-right: 8px;\n  }\n}\n\n.csvtables {\n  margin-bottom: 100px;\n}\n\n.tableClass {\n  max-height: 300px;\n}\n\n.simple {\n  td {\n    color: #6d717a;\n  }\n}\n\n.withHeader {\n  th {\n    color: #6d717a !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrapper": `pages-Companies-styles___loaderWrapper--oYUDS`,
	"tabs": `pages-Companies-styles___tabs--cSemB`,
	"tab": `pages-Companies-styles___tab--XNwGS`,
	"loyalityTabs": `pages-Companies-styles___loyalityTabs--gixpI`,
	"companyNameContainer": `pages-Companies-styles___companyNameContainer--W2mno`,
	"chips": `pages-Companies-styles___chips--Zb1oC`,
	"brex": `pages-Companies-styles___brex--VDu6m`,
	"agency": `pages-Companies-styles___agency--GWuX9`,
	"fraud": `pages-Companies-styles___fraud--XImri`,
	"labelStatusDisabled": `pages-Companies-styles___labelStatusDisabled--_UDUv`,
	"buttonDeactivateCompany": `pages-Companies-styles___buttonDeactivateCompany--TtNCA`,
	"deactivateCompanyButtonContainer": `pages-Companies-styles___deactivateCompanyButtonContainer--dCGEW`,
	"buttonReactivateCompany": `pages-Companies-styles___buttonReactivateCompany--DbHYH`,
	"reactivateCompanyButtonContainer": `pages-Companies-styles___reactivateCompanyButtonContainer--CZ4B1`,
	"container": `pages-Companies-styles___container--V6YS4`,
	"content": `pages-Companies-styles___content--MSAuv`,
	"sidebar": `pages-Companies-styles___sidebar--hp7OY`,
	"importTextContainer": `pages-Companies-styles___importTextContainer--ojdaH`,
	"info": `pages-Companies-styles___info--eGlso`,
	"warn": `pages-Companies-styles___warn--W451H`,
	"error": `pages-Companies-styles___error--a7MOo`,
	"csvtables": `pages-Companies-styles___csvtables--TQxlL`,
	"tableClass": `pages-Companies-styles___tableClass--jlyru`,
	"simple": `pages-Companies-styles___simple--wCqNX`,
	"withHeader": `pages-Companies-styles___withHeader--AsBLM`
};
module.exports = ___CSS_LOADER_EXPORT___;
